<template>
    <div class="flex h-full">
        <div class="h-full flex-1">
            <div class="flex flex-col justify-between h-full">
                <div class="flex items-center ">
                    <div class="mr-8">收银台</div>
                    <el-button type="primary" size="medium" @click="setShowProductDialog">+{{ $t('选择商品') }}</el-button>
                </div>
                <div class="table flex-1" v-if="products.length">
                    <div class="tr th">
                        <div v-for="(title, index) in titles" :key="index">{{ $t(title) }}</div>
                    </div>
                    <div class="tr td" v-for="(item, index) in products" :key="item.id">
                        <div class="product">
                            <img :src="$firstImage(item.images, 'small')">
                            <span class="font-semibold text-left">{{ item.name }}</span>
                            <div class="space-x-3 text-gray-600 text-sm">
                                <template v-if="item.complete_attrs">
                                    <span class="text-main">{{ item.complete_attrs.color }}</span>
                                    <span>{{ item.complete_attrs.level || '' }}</span>
                                    <span>{{ item.complete_attrs.norm || '' }}</span>
                                    <span>{{ item.complete_attrs.maturity || '' }}</span>
                                    <span>{{ item.complete_attrs.length || '' }}</span>
                                </template>
                            </div>
                        </div>
                        <div>
                            <span class="line-through pr-4" v-if="item.setprice">{{ $p(item.price) }}</span>
                            <el-link @click="setPrice(item, $p(calcPrice(item)))">{{ $p(calcPrice(item))
                            }}</el-link>
                        </div>
                        <div>{{ item.stock }}</div>
                        <el-input-number :min="0" :max="item.stock" label="描述文字" size="small" v-model="item.quantity"
                            @change="setProductQuantity(index, $event)"></el-input-number>
                        <div class="text-red-600">{{ $p(calcPrice(item) * item.quantity) }}</div>
                        <div class="iconfont icon-shanchu text-gray-500" @click="delProduct(index)"></div>
                    </div>
                </div>
                <img :src="require(`@/assets/image/暂无收藏.png`)" class="mx-auto" v-else />

                <div class="flex-between bottom-bar">
                    <div class="left">
                        <span class="text-sm">{{ $t('合计') }}：</span>
                        <span>{{ $p(total.price) }}</span>
                    </div>
                    <div class="flex items-center right cursor-pointer">
                        <div @click="clearProducts"><span class="iconfont icon-shanchu"></span>{{ $t('清空') }}</div>
                        <div @click="setGuadanDialog">{{ $t('挂起') }}</div>
                        <div @click="setProducts">{{ $t('开单') }}（{{ total.counts }}）</div>
                    </div>
                </div>
            </div>

            <el-dialog :visible.sync="isShowProductDialog" :title="$t('选择商品')" destroy-on-close fullscreen>
                <SelectedProduct @confirmProduct="confirmProduct"></SelectedProduct>
            </el-dialog>
            <el-dialog :visible.sync="isGuadanDialog" :title="$t('挂单')" @close="guadanName = ''">
                <div class="guadan-dialog">
                    <input v-model="guadanName" :placeholder="$t('请输入名称备注')">
                    <div class="flex-center mt-10">
                        <el-button @click="isGuadanDialog = false">{{ $t('取消') }}</el-button>
                        <el-button type="primary" @click="confirmGuadan" :disabled="!guadanName">{{ $t('确认')
                            }}</el-button>
                    </div>
                </div>
            </el-dialog>
            <el-dialog :visible.sync="isAddressDialog" :show-close="false" @close="selectedAdrId = ''">
                <div class="address-dialog">
                    <div class="flex-between">
                        <span>{{ $t('选择地址') }}</span>
                        <span class="text-main cursor-pointer" @click="isAddAdrDialog = true">+ {{ $t('新增地址') }}</span>
                    </div>
                    <div class="address-box">
                        <div class="address text-left relative" v-for="item in adrPager.items" :key="item.id"
                            :class="{ 'active': selectedAdrId == item.id }" @click="selectedAdrId = item.id">
                            <div class="flex items-center">
                                <span class="iconfont icon-shouhuodi px-1 text-xl"></span>
                                <span class="text-white text-sm default" v-if="item.isdefault">{{ $t("默认") }}</span>
                                <span>{{ item.address }}</span>
                            </div>
                            <div class="pl-7 space-x-4">
                                <span>{{ item.receiver }} {{ item.phone }}</span>
                                <span class="text-gray-400 cursor-pointer" @click.stop="editAdr(item.id)">{{ $t('编辑')
                                    }}</span>
                                <span class="iconfont icon-shanchu text-gray-400 text-sm cursor-pointer"
                                    @click.stop="delAdr(item.id)"></span>
                            </div>
                            <span
                                class=" iconfont icon-xuanzhong absolute text-main transform scale-200 text-xs"></span>
                        </div>
                    </div>
                    <el-pagination background layout="prev, pager, next" :total="adrPager.total" class="mt-5"
                        @current-change="adrPageChange" :page-size="adrPager.size">
                    </el-pagination>
                    <div class="flex-center mt-5">
                        <el-button @click="isAddressDialog = false">{{ $t('取消') }}</el-button>
                        <el-button type="primary" :disabled="!selectedAdrId" @click="createOrder">{{ $t('确认')
                            }}</el-button>
                    </div>
                </div>
                <el-dialog append-to-body :visible.sync="isAddAdrDialog" :title="$t('新增收货地址')" center>
                    <AddAddress @reload="getAddress(), isAddAdrDialog = false">
                    </AddAddress>
                </el-dialog>
                <el-dialog append-to-body :visible.sync="isEditAdrDialog" :title="$t('修改收货地址')" center>
                    <AddAddress :addr_message="addr_message" :title="$t('修改')" v-if="isEditAdrDialog"
                        @remodify="getAddress(), isEditAdrDialog = false">
                    </AddAddress>
                </el-dialog>
            </el-dialog>
        </div>
        <template v-if="guadanProducts.length">
            <div class="line"></div>
            <div class="cashier-box">
                <div class="mb-6">{{ $t('挂单') }}</div>
                <div class="name flex-center" v-for="(item, index) in guadanProducts" :key="index"
                    :class="{ 'active': curGuadanIndex == index }" @click="setGuadan(index)">{{ item.name }}</div>
            </div>
        </template>
    </div>
</template>
<script>
import { ref, computed, watch } from "@vue/composition-api";
import AddAddress from "@/components/mine/addAddress.vue";
import SelectedProduct from "@/components/mine/selectedProduct"
export default {
    components: { AddAddress, SelectedProduct },
    setup(props, ctx) {
        // start  已选商品
        const titles = ['商品', '单价', '库存', '数量', '金额', '删除']
        const products = ref([])
        products.value = ctx.root.$getStorage('scanPurchaseProducts') || []
        const setProductQuantity = async (index, e) => {
            if (e == 0) {
                products.value.splice(index, 1)
            }
        }
        const delProduct = (index) => {
            products.value.splice(index, 1)
        }
        const clearProducts = async () => {
            if (!products.value.length) return ctx.root.$toast(ctx.root.$t('请先选择商品'), 'warning')
            const res = await ctx.root.$query(ctx.root.$t("确定要清空所有商品吗?"))
            if (!res) return
            products.value = []
        }
        const total = computed(() => {
            let counts = 0
            let price = 0

            products.value?.map(i => {
                if (i.stock > 0) {
                    price += i.quantity ? (i.setprice || i.finalPrice || i.price) * Number(i.quantity) : 0
                    counts += i.quantity ? Number(i.quantity) : 0
                }
            })

            return {
                counts,
                price: Math.floor(price * 100) / 100
            }
        })
        watch(() => products.value, (newVal, oldVal) => {
            ctx.root.$setStorage('scanPurchaseProducts', newVal)
            let guadanLength = guadanProducts.value?.length
            if (curGuadanIndex.value > -1 && guadanLength > curGuadanIndex.value) {
                if (!newVal.length) {
                    const newArray = [...guadanProducts.value]
                    newArray.splice(curGuadanIndex.value, 1)
                    guadanProducts.value = [...newArray]
                    curGuadanIndex.value = -1
                } else {
                    guadanProducts.value[curGuadanIndex.value].products = newVal
                }
                ctx.root.$setStorage('guadanProducts', guadanProducts.value)

            }
        }, { deep: true })
        // end

        //start 商品价格
        const calcPrice = (item) => {
            if (item.setprice) {
                return item.setprice.toFixed(2)
            }
            let curBulk = null
            if (item.bulk && item.bulk.length && item.bulkable) {
                item.bulk.map(v => {
                    curBulk = v.quantity <= item.quantity ? v : curBulk
                })
            }
            let price = curBulk ? (item.price - curBulk.reduce) : item.price
            price = price.toFixed(2)
            // this.$set(item, 'finalPrice', price)
            return price
        }
        //end

        // start 选择商品
        const isShowProductDialog = ref(false)
        const setShowProductDialog = async () => {
            isShowProductDialog.value = true
        }

        //end



        // start 处理销量展示
        const changeval = (v) => {
            if (v > 10000) {
                return (v / 10000).toFixed(1) + '万'
            }
            return v
        }
        // end

        // start 选择商品

        const confirmProduct = async (selectedProducts) => {
            if (!selectedProducts.length) {
                return ctx.root.$toast(ctx.root.$t('请选择商品'), 'warning')
            }
            for (let i = 0; i < selectedProducts.length; i++) {
                let item = selectedProducts[i]
                if (cheakItemExist(item, item.quantity)) continue
                let res = await ctx.root.$callapi('getProductByScan', { pid: item.id })
                if (cheakItemExist(res.data, item.quantity)) continue
                if (res && res.data) {
                    res.data.quantity = res.data.stock >= item.quantity ? item.quantity : res.data.stock
                    products.value.push(res.data)
                }
            }

            isShowProductDialog.value = false
        }
        // end

        // start 检查选择商品是否已经存在
        const cheakItemExist = (item, quantity) => {
            let index = products.value.findIndex(product => product.id == item.id)
            if (index > -1) {
                let oldQuantity = products.value[index].quantity
                console.log(oldQuantity, quantity);
                let newQuantity = oldQuantity + quantity
                console.log(newQuantity);
                if (newQuantity > item.stock) {
                    newQuantity = item.stock
                }
                products.value[index] = JSON.parse(JSON.stringify(item))
                products.value[index].quantity = newQuantity
                return true
            } else {
                return false
            }
        }
        //end

        // start 挂单
        const isGuadanDialog = ref(false)
        const curGuadanIndex = ref(-1)
        curGuadanIndex.value = ctx.root.$getStorage('guadanIndex')
        const guadanName = ref('')
        const guadanProducts = ref([])
        guadanProducts.value = ctx.root.$getStorage('guadanProducts') || []
        const confirmGuadan = () => {
            guadanProducts.value.push({
                name: guadanName.value,
                products: JSON.parse(JSON.stringify(products.value))
            })

            ctx.root.$setStorage('guadanProducts', guadanProducts.value)
            products.value = []
            isGuadanDialog.value = false

        }
        const setGuadan = (index) => {
            curGuadanIndex.value = index
            products.value = guadanProducts.value[index].products
        }
        watch(() => curGuadanIndex.value, (newVal, oldVal) => {
            ctx.root.$setStorage('guadanIndex', newVal)
        })

        const setGuadanDialog = () => {
            if (products.value?.length && curGuadanIndex.value > -1) {
                curGuadanIndex.value = -1
                products.value = []
            } else if (products.value.length && curGuadanIndex.value == -1) {
                isGuadanDialog.value = true
            } else if (!products.value.length) {
                return ctx.root.$toast(ctx.root.$t('请先选择商品'), 'warning')
            }
        }
        // end

        // start 地址
        const isAddressDialog = ref(false)
        const adrPager = ref(
            new ctx.root.$Pager({
                apiname: 'user/getAddressList',
                size: 10
            })
        )
        const getAddress = async () => {
            await adrPager.value.first()
        };
        const adrPageChange = async (e) => {
            await adrPager.value.load(e)
        }
        const isAddAdrDialog = ref(false)
        const addr_message = ref({})
        const isEditAdrDialog = ref(false)
        const editAdr = async (id) => {
            ctx.root.$doing()
            const addr_item = await ctx.root.$callapi("user/getAddress", { aid: id });
            const res = await ctx.root.$callapi("getAddressByLatLng", {
                longitude: addr_item.data.longitude,
                latitude: addr_item.data.latitude,
            });
            ctx.root.$done()
            if (addr_item.code == 0 && addr_item.data) {
                addr_message.value = addr_item.data;
            }
            addr_message.value.areanames = res.data?.areastext ? res.data.areastext : ctx.root.$t("未知区域");
            isEditAdrDialog.value = true
        }
        const delAdr = async (id) => {
            ctx.root.$doing()
            let res = await ctx.root.$callapi('user/doAddressAction', { action: 'del', address_id: id })
            ctx.root.$done()
            if (res.code == 0 && res.data) {
                getAddress()
            }

        }
        // end

        //  start 开单
        const setProducts = async () => {
            if (!products.value.length) return ctx.root.$toast(ctx.root.$t('请先选择商品'), 'warning')
            await getAddress()
            isAddressDialog.value = true
        }
        const selectedAdrId = ref('')

        const createOrder = async () => {
            if (!total.value.counts) {
                return ctx.root.$toast(ctx.root.$t('请选择商品'), 'warning')
            }
            let pps = {}
            let itemsjson = {}
            products.value.map(item => {
                if (item.quantity > 0) {
                    pps[item.id] = item.quantity
                    itemsjson[item.id] = {
                        product_id: item.id,
                        quantity: item.quantity,
                        setprice: item.setprice || 0
                    }
                }
            })
            let param = {
                scene: 'products',
                param: { pid2quantity: pps, itemsjson: JSON.stringify(itemsjson) },
                syj: true,
                address_id: selectedAdrId.value
            }
            ctx.root.$doing()
            let res = await ctx.root.$callapi('user/createOrder', param)
            ctx.root.$done()
            if (res.code == 0 && res.data) {
                await ctx.root.$toast(ctx.root.$t('订单创建成功'), 'success')
                products.value = []
                ctx.root.$router.push({
                    path: "/mine/order/origin",
                    query: {
                        q: 'unpay'
                    }
                });
            }
        }
        // end

        //start 
        const setPrice = async (item, price) => {
            let name = item.name
            ctx.root.$prompt(`${ctx.root.$t("请填写")}【${name}】${ctx.root.$t("价格")}`, ctx.root.$t('提示'), {
                confirmButtonText: ctx.root.$t('确认'),
                cancelButtonText: ctx.root.$t('取消'),
                inputPattern: /^\d+(\.\d{1,2})?$/,
                inputErrorMessage: ctx.root.$t('请输入正确的价格')
            }).then(async ({ value }) => {
                let param = {
                    pid: item.id,
                    price: price,
                    scanpurchase: true,
                }
                if (value && parseFloat(value)) {
                    param.price = ctx.root.$transCNY(value && parseFloat(value))
                    let res = await ctx.root.$callapi('setCartprice', param)
                    if (res && res.data) {
                        ctx.root.$set(item, 'setprice', param.price)
                    }
                }
            }).catch(() => {
            });
        }
        //end

        return {
            titles, isShowProductDialog, setShowProductDialog, setProductQuantity,
            changeval, confirmProduct, products, delProduct,
            calcPrice, clearProducts, total, isGuadanDialog, guadanName, confirmGuadan, guadanProducts, curGuadanIndex, setGuadan,
            setProducts, isAddressDialog, selectedAdrId, adrPager, setPrice, setGuadanDialog,
            adrPageChange, isAddAdrDialog, getAddress, isEditAdrDialog, editAdr, addr_message, createOrder, delAdr
        }
    }
}
</script>
<style scoped lang="scss">
.table {
    @apply w-full mt-4;

    .tr {
        @apply grid place-items-center w-full;
        grid-template-columns: 2.5fr 1fr 1fr 1.5fr 1fr 1fr;

        &.th {
            height: 2.25rem;
            background-color: #F4F4F5;
        }

        &.td {
            height: 4.625rem;
            border-top: 1px solid #EEEEEE;

            .product {
                @apply grid;
                justify-self: flex-start;
                align-self: center;
                grid-template-columns: 3.19rem auto;
                grid-column-gap: 0.5rem;

                img {
                    width: 3.19rem;
                    height: 3.19rem;
                    grid-row: 1/3;
                }
            }
        }
    }
}

.bottom-bar {
    height: 2.875rem;
    background-color: #282B3C;
    color: #ffffff;
    padding-left: 1.875rem;
    margin-left: -2rem;
    margin-bottom: -2rem;

    .right {
        @apply h-full;

        &>div {
            @apply h-full;
            width: 8.94rem;
            text-align: center;
            line-height: 2.875rem;
            background-color: #FF4747;

            &:nth-child(2) {
                background-color: #34B66B;
            }
        }
    }
}

.products-dialog {
    .classifies {
        cursor: pointer;
    }

    .products {
        @apply grid mt-4;
        grid-template-columns: repeat(2, 1fr);
        gap: 0.5rem;

        .product {
            @apply grid w-full;
            grid-template-columns: 6rem auto;
            grid-column-gap: 0.4rem;
            border: 1px solid #eeeeee;
            padding: 0.4rem;

            img {
                grid-row: 1/5;
            }
        }
    }
}

.guadan-dialog {
    input {
        width: 23.38rem;
        height: 4.44rem;
        background: #efefef;
        text-align: center;
        color: #333333;
        outline: none;
    }

    .el-button {
        width: 7.5rem;
    }
}

.line {
    width: 0.625rem;
    background-color: #F4F4F4;
    margin-top: -2rem;
    margin-bottom: -2rem;
}

.cashier-box {
    width: 9.67rem;
    margin-right: -2rem;
    padding: 0 0.62rem;

    .name {
        height: 4.313rem;
        border: 0.063rem solid #e3e3e3;
        margin-bottom: 0.63rem;

        &.active {
            background-color: #34B66B;
            color: #ffffff;
        }
    }
}

.address-dialog {
    margin-top: -2rem;

    .address-box {
        @apply grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 1rem;
        margin-top: 1rem;

        .address {
            border: 0.063rem solid #e2e2e2;
            padding: 0.4rem 0;
            overflow: hidden;

            .default {
                background: #34b66b26;
                color: #34B66B;
                padding: 0.1rem 0.2rem;
                margin-right: 0.2rem;
                border-radius: 0.25rem;
            }


            .icon-shouhuodi {
                color: #34B66B;
            }

            .icon-xuanzhong {
                @apply hidden;
                top: 3px;
                left: 5px;
            }

            &.active {
                border: 0.063rem solid #34b66b;

                .icon-xuanzhong {
                    @apply block;
                }
            }
        }
    }
}
</style>